var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 89,
    viewBox: "0 0 92 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -23.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 3.5,
    fill: "#ED1C24",
    stroke: "#F8B3B6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 65.5,
    width: 47,
    height: 47,
    rx: 3.5,
    fill: "#ED1C24",
    stroke: "#F8B3B6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 0.5,
    width: 47,
    height: 58,
    rx: 3.5,
    fill: "#ED1C24",
    stroke: "#F8B3B6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -23.5,
    y: 55.5,
    width: 47,
    height: 57,
    rx: 3.5,
    fill: "#ED1C24",
    stroke: "#F8B3B6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -15.5,
    y: 7.5,
    width: 99,
    height: 99,
    rx: 49.5,
    fill: "#ED1C24"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -15.5,
    y: 7.5,
    width: 99,
    height: 99,
    rx: 49.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 48H26C25.4477 48 25 48.4477 25 49V56C25 56.5523 25.4477 57 26 57H31C31.5523 57 32 56.5523 32 56V49C32 48.4477 31.5523 48 31 48Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 48H37C36.4477 48 36 48.4477 36 49V52C36 52.5523 36.4477 53 37 53H42C42.5523 53 43 52.5523 43 52V49C43 48.4477 42.5523 48 42 48Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57H37C36.4477 57 36 57.4477 36 58V65C36 65.5523 36.4477 66 37 66H42C42.5523 66 43 65.5523 43 65V58C43 57.4477 42.5523 57 42 57Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 61H26C25.4477 61 25 61.4477 25 62V65C25 65.5523 25.4477 66 26 66H31C31.5523 66 32 65.5523 32 65V62C32 61.4477 31.5523 61 31 61Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopIcon);
export default __webpack_public_path__ + "static/media/desktopIcon.3833ab127a810aac3bcb8760a78a45e3.svg";
export { ForwardRef as ReactComponent };